import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import moment from 'moment';
import { chartColor } from "../../utils/commonConsts";
import { get_line_config as _get_line_config } from "../../services/CI/CI1401S";
import { get_link, get_link_list as _get_link_list, get_link_path, get_wan_info as _get_wan_info, get_wifi as _get_wifi, get_wifi_config_file as _get_wifi_config_file, update_device as _update_device, get_bgp as _get_bgp, get_bgp_his as _get_bgp_his, get_bgp_ip as _get_bgp_ip, get_device_list as _get_device_list, get_link_ping_detect_detail, get_link_ping_detect as _get_link_ping_detect } from "../../services/Company/companyS";
import { get_days4g as _get_days4g, get_interface, get_main_flow as _get_main_flow, get_multi_band, get_path_miss as _get_path_miss, get_path_rtt as _get_path_rtt, get_session_ct, get_system as _get_system, get_tunnel_agent, get_wans as _get_wans, get_path_seg as _get_path_seg, get_4g_strength_latest as _get_4g_strength_latest, get_4g_strength_line as _get_4g_strength_line, get_tunnel_property as _get_tunnel_property, get_internet_property as _get_internet_property, get_real_working_path } from "../../services/rate/rateS";
import { get_cpe_template_agency as _get_cpe_template_agency, get_physical_ports_info as _get_physical_ports_info, get_ap_wifi as _get_ap_wifi, get_ap_lan as _get_ap_lan, get_ap_static_ip as _get_ap_static_ip, create_ap_static_ip as _create_ap_static_ip, update_ap_static_ip as _update_ap_static_ip, delete_ap_static_ip as _delete_ap_static_ip, create_ap_lan as _create_ap_lan, update_ap_lan as _update_ap_lan, delete_ap_lan as _delete_ap_lan, create_ap_wifi as _create_ap_wifi, update_ap_wifi as _update_ap_wifi, delete_ap_wifi as _delete_ap_wifi, get_latest_lan_name, get_start_end_ip as _get_start_end_ip } from "../../services/CI/CI2802S";
import { BossMessage } from "../../components/Common/BossMessages";
import { ipTypeMap } from '../../utils/commonUtilFunc';
export default {
  namespace: "mi0102Info",
  state: {
    ctaId: "",
    physical: [],
    cpeTemplate: [],
    apTemplate: [],
    apStatic: [],
    wifiList: [],
    wanInfo: [],
    dataLan: [],
    deviceInfo: {},
    link_path: [],
    linkList: [],
    selectedLinkId: "",
    tunnelList: [],
    selectedTunnel: "",
    sysInfoDataSeries: [],
    selectedWan: "",
    selectedWanInfo: {},
    wanInfoDataSeries: {
      speed: [],
      rttMiss: [],
      getPost: []
    },
    tunnelInfoSeries: {
      speed: [],
      session: [],
      rttGet: [],
      tunnelStatus: [],
      jitter: [],
      rtt: [],
      getData: []
    },
    days4gSeries: [],
    wanTimeInterval: "0",
    timeInterval4G: "0",
    refreshType: "0",
    selectedTunnelBandwidth: 0,
    linkInfo: [],
    deviceList: [],
    agencyinfo: [],
    ifNoSystemData: true,
    hcpeSpeedSeries: [],
    hasHcpeSpeed: false,
    wifiFile: "",
    pathRtt: [],
    pathMiss: [],
    pathInfo: {
      dst_info: {},
      src_info: {
        ip_table_list: []
      },
      path_info: []
    },
    pathSeg: [],
    ipPool: [],
    ipsetInfo: [],
    bgpList: [],
    bgphisList: [],
    bgpipList: {
      recv: [],
      send: []
    },
    series_4g_strength_line: [],
    tunnel_property_data: {
      rtt: [],
      jitter: [],
      miss: []
    },
    internet_property_data: {
      rtt: [],
      jitter: [],
      miss: []
    },
    multiBandSeries: [],
    ispData: ''
  },
  effects: {
    get_path_miss: function get_path_miss(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var missGetData, arr, timeInterval, start_date, end_date, key, getSeries, keys, time, miss, name, timeArr, i, tempGet;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(_get_path_miss, payload);
            case 2:
              missGetData = _context.sent;
              arr = [];
              timeInterval = 0;
              start_date = moment(payload.start_tm, "YYYY-MM-DD HH:mm:ss");
              end_date = moment(payload.end_tm, "YYYY-MM-DD HH:mm:ss");
              if (start_date && end_date && end_date.diff(start_date, "seconds")) {
                if (end_date.diff(start_date, "seconds") <= 86400) {
                  //24小时
                  timeInterval = 90;
                } else {
                  timeInterval = 10800;
                }
              }
              for (key in missGetData.data) {
                getSeries = {
                  name: missGetData.data[key].pathname,
                  data: [],
                  type: "line",
                  showSymbol: false,
                  smoothMonotone: "x",
                  smooth: true,
                  animation: false,
                  lineStyle: {
                    color: chartColor[key]
                  },
                  itemStyle: {
                    color: chartColor[key]
                  }
                };
                if (missGetData.msg === "ok") {
                  for (keys in missGetData.data[key].pathinfo) {
                    time = moment.unix(missGetData.data[key].pathinfo[keys].time).format("YYYY-MM-DD HH:mm:ss");
                    miss = missGetData.data[key].pathinfo[keys].miss;
                    name = missGetData.data[key].pathinfo[keys].pathname;
                    timeArr = [];
                    ;
                    if (missGetData.data[key].pathinfo.length > 3 && missGetData.data[key].pathinfo[Number(keys) - 1]) {
                      if (missGetData.data[key].pathinfo[Number(keys) - 1].time && missGetData.data[key].pathinfo[keys].time - missGetData.data[key].pathinfo[Number(keys) - 1].time > timeInterval) {
                        timeArr.push(moment.unix(missGetData.data[key].pathinfo[Number(keys) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                        timeArr.push(moment.unix(missGetData.data[key].pathinfo[Number(keys)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                      }
                    }
                    if (timeArr.length > 0) {
                      for (i in timeArr) {
                        getSeries.data.push([timeArr[i], null, name]);
                      }
                    }
                    tempGet = [time, miss, name];
                    getSeries.data.push(tempGet);
                  }
                }
                arr.push(getSeries);
              }
              _context.next = 11;
              return put({
                type: "update",
                payload: {
                  pathMiss: arr
                }
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    get_path_rtt: function get_path_rtt(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var rttGetData, rtt, timeInterval, start_date, end_date, key, getSeries, keys, time, rtts, name, timeArr, i, tempGet;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_get_path_rtt, payload);
            case 2:
              rttGetData = _context2.sent;
              rtt = [];
              timeInterval = 0;
              start_date = moment(payload.start_tm, "YYYY-MM-DD HH:mm:ss");
              end_date = moment(payload.end_tm, "YYYY-MM-DD HH:mm:ss");
              if (start_date && end_date && end_date.diff(start_date, "seconds")) {
                if (end_date.diff(start_date, "seconds") <= 86400) {
                  //24小时
                  timeInterval = 90;
                } else {
                  timeInterval = 10800;
                }
              }
              for (key in rttGetData.data) {
                getSeries = {
                  name: rttGetData.data[key].pathname,
                  data: [],
                  type: "line",
                  showSymbol: false,
                  smoothMonotone: "x",
                  smooth: true,
                  animation: false,
                  lineStyle: {
                    color: chartColor[key]
                  },
                  itemStyle: {
                    color: chartColor[key]
                  }
                };
                if (rttGetData.msg === "ok") {
                  for (keys in rttGetData.data[key].pathinfo) {
                    time = moment.unix(rttGetData.data[key].pathinfo[keys].time).format("YYYY-MM-DD HH:mm:ss");
                    rtts = rttGetData.data[key].pathinfo[keys].rtt;
                    name = rttGetData.data[key].pathinfo[keys].pathname;
                    timeArr = [];
                    ;
                    if (rttGetData.data[key].pathinfo.length > 3 && rttGetData.data[key].pathinfo[Number(keys) - 1]) {
                      if (rttGetData.data[key].pathinfo[Number(keys) - 1].time && rttGetData.data[key].pathinfo[keys].time - rttGetData.data[key].pathinfo[Number(keys) - 1].time > timeInterval) {
                        timeArr.push(moment.unix(rttGetData.data[key].pathinfo[Number(keys) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                        timeArr.push(moment.unix(rttGetData.data[key].pathinfo[Number(keys)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                      }
                    }
                    if (timeArr.length > 0) {
                      for (i in timeArr) {
                        getSeries.data.push([timeArr[i], null, name]);
                      }
                    }
                    tempGet = [time, rtts, name];
                    getSeries.data.push(tempGet);
                  }
                }
                rtt.push(getSeries);
              }
              _context2.next = 11;
              return put({
                type: "update",
                payload: {
                  pathRtt: rtt
                }
              });
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    update_device: function update_device(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(_update_device, payload);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    get_wan_info: function get_wan_info(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData, key, backData1;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(_get_wan_info, {
                sn: payload.sn
              });
            case 2:
              backData = _context4.sent;
              if (!(backData.success && backData.result)) {
                _context4.next = 13;
                break;
              }
              _context4.t0 = _regeneratorRuntime().keys(backData.result);
            case 5:
              if ((_context4.t1 = _context4.t0()).done) {
                _context4.next = 13;
                break;
              }
              key = _context4.t1.value;
              _context4.next = 9;
              return call(get_interface, {
                sn: payload.sn,
                iface: backData.result[key]["interface"],
                company_id: payload.company_id
              });
            case 9:
              backData1 = _context4.sent;
              if (backData1.msg === "ok") {
                backData.result[key].upDownInfo = backData1.data;
              } else {
                backData.result[key].upDownInfo = [];
              }
              _context4.next = 5;
              break;
            case 13:
              _context4.next = 15;
              return put({
                type: "update",
                payload: {
                  wanInfo: backData.result,
                  selectedWan: backData.result[0] ? backData.result[0].id : "",
                  selectedWanInfo: backData.result[0] || {}
                }
              });
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    get_device_list: function get_device_list(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_get_device_list, payload);
            case 2:
              backData = _context5.sent;
              _context5.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceInfo: backData.result[0] || {}
                }
              });
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    //设备页面跳转进来获取链路信息以及隧道信息
    get_link_list: function get_link_list(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData, temp, getLinkBackData, linkPathData;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_get_link_list, payload);
            case 2:
              backData = _context6.sent;
              temp = [];
              try {
                temp = backData.result.map(function (item) {
                  return {
                    name: "tunnel_" + item.name,
                    value: item.id,
                    bandwidth: item.bandwidth,
                    cname: item.name
                  };
                });
              } catch (e) {
                console.warn(e);
              }
              _context6.next = 7;
              return put({
                type: "update",
                payload: {
                  tunnelList: temp,
                  selectedTunnel: temp[0] ? temp[0].value : "",
                  selectedTunnelBandwidth: temp[0] ? temp[0].bandwidth : 0,
                  linkList: backData.result,
                  selectedLinkId: backData.result[0] ? backData.result[0].id : ""
                }
              });
            case 7:
              if (!backData.result[0]) {
                _context6.next = 18;
                break;
              }
              _context6.next = 10;
              return call(get_link, {
                id: backData.result[0] ? backData.result[0].id : ""
              });
            case 10:
              getLinkBackData = _context6.sent;
              _context6.next = 13;
              return call(get_link_path, {
                link_id: backData.result[0] ? backData.result[0].id : ""
              });
            case 13:
              linkPathData = _context6.sent;
              _context6.next = 16;
              return put({
                type: "update",
                payload: {
                  linkInfo: [getLinkBackData.link_info],
                  deviceList: getLinkBackData.device_list,
                  agencyinfo: getLinkBackData.agency_list,
                  link_path: linkPathData.result
                }
              });
            case 16:
              _context6.next = 20;
              break;
            case 18:
              _context6.next = 20;
              return put({
                type: "update",
                payload: {
                  linkInfo: [],
                  deviceList: [],
                  agencyinfo: [],
                  link_path: []
                }
              });
            case 20:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    //链路页面跳转进来获取隧道信息
    set_tunnel_info: function set_tunnel_info(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return put({
                type: "update",
                payload: {
                  selectedTunnel: payload.id,
                  tunnelList: [{
                    name: "tunnel_" + payload.id,
                    value: payload.id
                  }]
                }
              });
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    handleSelectLink: function handleSelectLink(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var getLinkBackData, getLinkPathData;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(get_link, {
                id: payload.link_id
              });
            case 2:
              getLinkBackData = _context8.sent;
              _context8.next = 5;
              return call(get_link_path, {
                link_id: payload.link_id
              });
            case 5:
              getLinkPathData = _context8.sent;
              _context8.next = 8;
              return put({
                type: "update",
                payload: {
                  linkInfo: [getLinkBackData.link_info],
                  deviceList: getLinkBackData.device_list,
                  agencyinfo: getLinkBackData.agency_list,
                  selectedLinkId: payload.link_id,
                  link_path: getLinkPathData.result
                }
              });
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    changeTunnel: function changeTunnel(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return put({
                type: "update",
                payload: {
                  selectedTunnel: payload.tunnel,
                  selectedTunnelBandwidth: payload.bandwidth
                }
              });
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    changeWan: function changeWan(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return put({
                type: "update",
                payload: {
                  selectedWan: payload.selectedWan,
                  selectedWanInfo: payload.selectedWanInfo
                }
              });
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    get_system: function get_system(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var backData, start_date, end_date, timeInterval, sysInfoData, sysInfoDataSeries, startKey, primKey, key, cpuKey, diskKey, _key2, timeArr, time, subKey, _cpuKey2, i, _diskKey2, _i2, _i4, _key4, num, name, temp;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return call(_get_system, payload);
            case 2:
              backData = _context11.sent; // const backData1 = yield call(get_alarm_list, payload);
              start_date = moment(payload.start_tm, "YYYY-MM-DD HH:mm:ss");
              end_date = moment(payload.end_tm, "YYYY-MM-DD HH:mm:ss");
              timeInterval = 0;
              if (start_date && end_date && end_date.diff(start_date, "seconds")) {
                if (end_date.diff(start_date, "seconds") <= 86400) {
                  //24小时
                  timeInterval = 90;
                } else {
                  timeInterval = 10800;
                }
              }
              sysInfoData = {};
              sysInfoDataSeries = []; // let tempSeries: any = {
              //     type: "line",
              //     step: "start",
              //     yAxisIndex: 1,
              //     name: "ONLINE-OFFLINE",
              //     data: [],
              //     showSymbol: false,
              //     animation: false,
              //     lineStyle: {
              //         color: "#59D54F"
              //     },
              //     itemStyle: {
              //         color: "#59D54F"
              //     }
              // };
              if (!(backData.msg === "ok" || backData.retcode === 0)) {
                _context11.next = 61;
                break;
              }
              if (!(backData.data && Array.isArray(backData.data) && backData.data.length > 0)) {
                _context11.next = 61;
                break;
              } //构造sysInfo基本数据结构
              startKey = 0;
              backData.data.map(function (item, index) {
                if (item.cpus.length > 0 && item.disk.length > 0) {
                  startKey = index;
                }
              });
              _context11.t0 = _regeneratorRuntime().keys(backData.data);
            case 14:
              if ((_context11.t1 = _context11.t0()).done) {
                _context11.next = 36;
                break;
              }
              primKey = _context11.t1.value;
              _context11.t2 = _regeneratorRuntime().keys(backData.data[primKey]);
            case 17:
              if ((_context11.t3 = _context11.t2()).done) {
                _context11.next = 34;
                break;
              }
              key = _context11.t3.value;
              if (!(key === "cpus")) {
                _context11.next = 24;
                break;
              }
              for (cpuKey in backData.data[primKey].cpus) {
                if (cpuKey < backData.data[startKey].cpus.length) {
                  sysInfoData["cpu" + cpuKey] = {
                    name: "cpu" + cpuKey,
                    data: [],
                    yAxisIndex: 0,
                    smoothMonotone: "x",
                    smooth: true,
                    animation: false
                  };
                }
              }
              return _context11.abrupt("continue", 17);
            case 24:
              if (!(key === "disk")) {
                _context11.next = 29;
                break;
              }
              if (backData.data[primKey].disk.length > 0) {
                for (diskKey in backData.data[primKey].disk) {
                  sysInfoData[backData.data[primKey].disk[diskKey].name] = {
                    name: "Disk-" + backData.data[primKey].disk[diskKey].name,
                    data: [],
                    yAxisIndex: 0,
                    showSymbol: false,
                    smoothMonotone: "x",
                    smooth: true,
                    animation: false,
                    connectNulls: false
                  };
                }
              }
              return _context11.abrupt("continue", 17);
            case 29:
              if (!(key === "time")) {
                _context11.next = 31;
                break;
              }
              return _context11.abrupt("continue", 17);
            case 31:
              sysInfoData[key] = {
                name: key,
                data: [],
                yAxisIndex: 0,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                connectNulls: false
              };
              _context11.next = 17;
              break;
            case 34:
              _context11.next = 14;
              break;
            case 36:
              _context11.t4 = _regeneratorRuntime().keys(backData.data);
            case 37:
              if ((_context11.t5 = _context11.t4()).done) {
                _context11.next = 60;
                break;
              }
              _key2 = _context11.t5.value;
              timeArr = [];
              if (backData.data.length > 3 && backData.data[Number(_key2) - 1]) {
                if (backData.data[Number(_key2) - 1].time && backData.data[_key2].time - backData.data[Number(_key2) - 1].time > timeInterval) {
                  // let t=backData.data[Number(key)-1].time;
                  // while (t<= backData.data[Number(key)].time) { 
                  //     t=t+timeInterval;
                  //     timeArr.push(moment.unix(t).format("YYYY-MM-DD HH:mm:ss"));
                  // }
                  timeArr.push(moment.unix(backData.data[Number(_key2) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                  timeArr.push(moment.unix(backData.data[Number(_key2)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                }
              }
              time = moment.unix(backData.data[_key2].time).format("YYYY-MM-DD HH:mm:ss");
              _context11.t6 = _regeneratorRuntime().keys(backData.data[_key2]);
            case 43:
              if ((_context11.t7 = _context11.t6()).done) {
                _context11.next = 58;
                break;
              }
              subKey = _context11.t7.value;
              _context11.t8 = subKey;
              _context11.next = _context11.t8 === "cpus" ? 48 : _context11.t8 === "disk" ? 50 : _context11.t8 === "mem" ? 52 : 55;
              break;
            case 48:
              for (_cpuKey2 in backData.data[_key2].cpus) {
                if (sysInfoData["cpu" + _cpuKey2]) {
                  if (timeArr.length > 0) {
                    for (i in timeArr) {
                      sysInfoData["cpu" + _cpuKey2].data.push([timeArr[i], null]);
                    }
                  }
                  sysInfoData["cpu" + _cpuKey2].data.push([time, backData.data[_key2].cpus[_cpuKey2]]);
                }
              }
              return _context11.abrupt("break", 56);
            case 50:
              if (backData.data[_key2].disk.length > 0) {
                for (_diskKey2 in backData.data[_key2].disk) {
                  if (sysInfoData[backData.data[_key2].disk[_diskKey2].name]) {
                    if (timeArr.length > 0) {
                      for (_i2 in timeArr) {
                        sysInfoData[backData.data[_key2].disk[_diskKey2].name].data.push([timeArr[_i2], null]);
                      }
                    }
                    sysInfoData[backData.data[_key2].disk[_diskKey2].name].data.push([time, backData.data[_key2].disk[_diskKey2].usage]);
                  }
                }
              }
              return _context11.abrupt("break", 56);
            case 52:
              if (timeArr.length > 0) {
                for (_i4 in timeArr) {
                  sysInfoData.mem.data.push([timeArr[_i4], null]);
                }
              }
              sysInfoData.mem.data.push([time, backData.data[_key2].mem]);
              return _context11.abrupt("break", 56);
            case 55:
              return _context11.abrupt("break", 56);
            case 56:
              _context11.next = 43;
              break;
            case 58:
              _context11.next = 37;
              break;
            case 60:
              for (_key4 in sysInfoData) {
                if (_key4.indexOf("cpu") > -1) {
                  num = _key4.replace("cpu", "");
                  name = "cpu" + (parseInt(num, 10) + 1);
                  sysInfoData[_key4].name = name;
                } //if语句里面给每个cpu名称序号+1
                temp = sysInfoData[_key4];
                temp.type = "line";
                temp.showSymbol = false;
                temp.symbol = "circle";
                sysInfoDataSeries.push(temp);
              }
            case 61:
              _context11.next = 63;
              return put({
                type: "update",
                payload: {
                  sysInfoDataSeries: sysInfoDataSeries,
                  ifNoSystemData: sysInfoDataSeries.length === 0
                }
              });
            case 63:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    get_wans: function get_wans(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData, wanInfoDataSeries, start_date, end_date, timeInterval, series_ratetx, series_raterx, series_rtt, series_miss, series_get, series_post, key, timeArr, data, time, i, rx, tx;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_get_wans, payload);
            case 2:
              backData = _context12.sent;
              wanInfoDataSeries = {
                speed: [],
                rttMiss: [],
                getPost: []
              };
              start_date = moment(payload.start_tm, "YYYY-MM-DD HH:mm:ss");
              end_date = moment(payload.end_tm, "YYYY-MM-DD HH:mm:ss");
              timeInterval = 0;
              if (start_date && end_date && end_date.diff(start_date, "seconds")) {
                if (end_date.diff(start_date, "seconds") <= 86400) {
                  //24小时
                  timeInterval = 90;
                } else if (end_date.diff(start_date, "seconds") > 86400 && end_date.diff(start_date, "month") <= 1) {
                  //大于24小时，小于1个月
                  timeInterval = 3600;
                } else {
                  //大于一个月
                  timeInterval = 43200;
                }
              }
              if (backData.msg === "ok" || backData.retcode === 0) {
                series_ratetx = {
                  type: "line",
                  data: [],
                  name: "Uplink bandwidth",
                  showSymbol: false,
                  smoothMonotone: "x",
                  smooth: true,
                  animation: false,
                  sampling: "max",
                  connectNulls: false,
                  lineStyle: {
                    color: "#3B9FF7"
                  },
                  itemStyle: {
                    color: "#3B9FF7"
                  }
                };
                series_raterx = {
                  type: "line",
                  data: [],
                  name: "downstream bandwidth ",
                  showSymbol: false,
                  smoothMonotone: "x",
                  smooth: true,
                  animation: false,
                  lineStyle: {
                    color: "#D396F5"
                  },
                  itemStyle: {
                    color: "#D396F5"
                  }
                };
                series_rtt = {
                  type: "line",
                  data: [],
                  name: "Network latency",
                  yAxisIndex: 0,
                  showSymbol: false,
                  smoothMonotone: "x",
                  smooth: true,
                  animation: false,
                  lineStyle: {
                    color: "#FF8D23"
                  },
                  itemStyle: {
                    color: "#FF8D23"
                  }
                };
                series_miss = {
                  type: "line",
                  data: [],
                  name: "Network packet loss",
                  yAxisIndex: 1,
                  showSymbol: false,
                  smoothMonotone: "x",
                  smooth: true,
                  animation: false,
                  lineStyle: {
                    color: "#BDA20A"
                  },
                  itemStyle: {
                    color: "#BDA20A"
                  }
                };
                series_get = {
                  type: "line",
                  data: [],
                  name: "GET",
                  showSymbol: false,
                  smoothMonotone: "x",
                  smooth: true,
                  animation: false,
                  lineStyle: {
                    color: "#059CAD"
                  },
                  itemStyle: {
                    color: "#059CAD"
                  }
                };
                series_post = {
                  type: "line",
                  data: [],
                  name: "POST",
                  showSymbol: false,
                  smoothMonotone: "x",
                  smooth: true,
                  animation: false,
                  lineStyle: {
                    color: "#89D7FF"
                  },
                  itemStyle: {
                    color: "#89D7FF"
                  }
                };
                if (backData.data.length > 0) {
                  for (key in backData.data) {
                    timeArr = [];
                    if (backData.data.length > 3 && backData.data[Number(key) - 1]) {
                      if (backData.data[Number(key) - 1].time && backData.data[key].time - backData.data[Number(key) - 1].time > timeInterval) {
                        timeArr.push(moment.unix(backData.data[Number(key) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                        timeArr.push(moment.unix(backData.data[Number(key)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                      }
                    }
                    data = backData.data[key];
                    time = moment.unix(backData.data[key].time).format("YYYY-MM-DD HH:mm:ss");
                    if (backData.data.length > 0) {
                      if (timeArr.length > 0) {
                        for (i in timeArr) {
                          series_get.data.push([timeArr[i], null]);
                          series_post.data.push([timeArr[i], null]);
                          series_miss.data.push([timeArr[i], null]);
                          series_rtt.data.push([timeArr[i], null]);
                          series_raterx.data.push([timeArr[i], null]);
                          series_ratetx.data.push([timeArr[i], null]);
                        }
                      }
                      series_get.data.push([time, data.get]);
                      series_post.data.push([time, data.post]);
                      series_miss.data.push([time, data.miss]);
                      series_rtt.data.push([time, data.rtt]);
                      rx = data.raterx / 1000;
                      tx = data.ratetx / 1000;
                      series_raterx.data.push([time, rx > 1000 ? 0.58 : rx.toFixed(4)]);
                      series_ratetx.data.push([time, tx > 1000 ? 0.58 : tx.toFixed(4)]);
                    }
                  }
                }
                wanInfoDataSeries.speed.push(series_ratetx);
                wanInfoDataSeries.speed.push(series_raterx);
                wanInfoDataSeries.rttMiss.push(series_miss);
                wanInfoDataSeries.rttMiss.push(series_rtt);
                wanInfoDataSeries.getPost.push(series_get);
                wanInfoDataSeries.getPost.push(series_post);
              }
              _context12.next = 11;
              return put({
                type: "update",
                payload: {
                  wanInfoDataSeries: wanInfoDataSeries
                }
              });
            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    //在页面从负载率跳转过来时,从url数据设定总带宽
    set_tunnel_bandwidth: function set_tunnel_bandwidth(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return put({
                type: "update",
                payload: {
                  selectedTunnelBandwidth: payload.bandwidth
                }
              });
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    get_main_flow: function get_main_flow(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData, hasHcpeSpeed, speedSeries, seriesTx, seriesRx, key, data, time;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_get_main_flow, payload);
            case 2:
              backData = _context14.sent;
              hasHcpeSpeed = false;
              speedSeries = [];
              seriesTx = {
                name: "Uplink rate",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#3B9FF7"
                },
                itemStyle: {
                  color: "#3B9FF7"
                }
              };
              seriesRx = {
                name: "Downlink rate",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#D396F5"
                },
                itemStyle: {
                  color: "#D396F5"
                }
              };
              if (backData.msg === "ok" || backData.retcode === 0) {
                for (key in backData.data) {
                  data = backData.data[key];
                  time = moment.unix(backData.data[key].time).format("YYYY-MM-DD HH:mm:ss");
                  seriesRx.data.push([time, (data.raterx * 8 / 1024).toFixed(4)]);
                  seriesTx.data.push([time, (data.ratetx * 8 / 1024).toFixed(4)]);
                }
                if (backData.data.length > 0) {
                  hasHcpeSpeed = true;
                }
              }
              speedSeries.push(seriesRx);
              speedSeries.push(seriesTx);
              _context14.next = 12;
              return put({
                type: "update",
                payload: {
                  hcpeSpeedSeries: speedSeries,
                  hasHcpeSpeed: hasHcpeSpeed
                }
              });
            case 12:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    get_tunnel_data: function get_tunnel_data(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put,
        select = _ref30.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var timeInterval, start_date, end_date, tunnelInfoSeries, tunnelStatusPayloadLink, speedSeries, speedData, multibandData, dataSource, name, color, key, tempSeriesTx, tempSeriesRx, subKey, timeArr, band, time, i, rttGetSeries, rttSeries, getSeries, getSeries2, alltunnelData, allInternetData, rttData, rttGetData, realPathData, realPathSeries, realPathSeriesJitter, realPathSeriesRtt, realPathSeriesMiss, _key6, _timeArr, _time, tempGet, _i6, _key8, _timeArr2, _time2, _tempGet, _i8, _key10, _timeArr3, _time3, tempRtt, _i10, sessionData, sessionSeries, _key12, _timeArr4, _i12, temp, jitterData, jitterSeries, _key14, _temp, JitterAndRttSeries, pingDetectLossSeries, pingDetectData, timeIntervalForPing, _key16, _timeArr5, jittertemp, rtttemp, losstemp, _i14;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              timeInterval = 0;
              start_date = moment(payload.start_tm, "YYYY-MM-DD HH:mm:ss");
              end_date = moment(payload.end_tm, "YYYY-MM-DD HH:mm:ss");
              if (start_date && end_date && end_date.diff(start_date, "seconds")) {
                if (end_date.diff(start_date, "seconds") <= 86400) {
                  //24小时
                  timeInterval = 90;
                } else if (end_date.diff(start_date, "seconds") > 86400 && end_date.diff(start_date, "month") <= 1) {
                  //大于24小时，小于1个月
                  timeInterval = 3600;
                } else {
                  //大于一个月
                  timeInterval = 43200;
                }
              }
              tunnelInfoSeries = {
                speed: [],
                session: [],
                rttGet: [],
                tunnelStatus: [],
                jitter: [],
                rtt: [],
                getData: [],
                JitterAndRtt: [],
                pingDetectLoss: [],
                realPath: []
              };
              tunnelStatusPayloadLink = {
                begin_time: payload.start_tm,
                end_time: payload.end_tm,
                link_id: payload.tid
              }; //数据获取
              speedSeries = [];
              _context15.next = 9;
              return call(get_multi_band, payload);
            case 9:
              multibandData = _context15.sent;
              dataSource = multibandData.data;
              name = "", color = [];
              _context15.t0 = _regeneratorRuntime().keys(dataSource);
            case 13:
              if ((_context15.t1 = _context15.t0()).done) {
                _context15.next = 46;
                break;
              }
              key = _context15.t1.value;
              _context15.t2 = dataSource[key].nettp;
              _context15.next = _context15.t2 === 1000 ? 18 : _context15.t2 === 0 ? 21 : _context15.t2 === 1 ? 24 : _context15.t2 === 2 ? 27 : _context15.t2 === 3 ? 30 : _context15.t2 === 4 ? 33 : 36;
              break;
            case 18:
              name = "Total rate";
              color = ['#FF0000', '#1A7C11'];
              return _context15.abrupt("break", 39);
            case 21:
              name = "MPLS";
              color = ['#1405a5bd', '#7CD7D7'];
              return _context15.abrupt("break", 39);
            case 24:
              name = "INTERNET";
              color = ['#cb7bf4', '#4b7cf3'];
              return _context15.abrupt("break", 39);
            case 27:
              name = "4G";
              color = ['#79A5C2', '#FF83AF'];
              return _context15.abrupt("break", 39);
            case 30:
              name = "INTERNET_PRIVIATE";
              color = ['#A16AC2', '#3CB1B1'];
              return _context15.abrupt("break", 39);
            case 33:
              name = "4G_PRIVIATE";
              color = ['#888CFF', '#AAE392'];
              return _context15.abrupt("break", 39);
            case 36:
              name = "";
              color = ['#2E9AC8', '#95C9F7'];
              return _context15.abrupt("break", 39);
            case 39:
              tempSeriesTx = {
                name: name + ' ' + "upstream",
                data: [],
                type: "line",
                nettype: dataSource[key].nettp,
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                color: color[0],
                markLine: {
                  data: [{
                    name: "Horizontal line with a Y-axis value of bandwidth * 0.9",
                    yAxis: payload && payload.showlinedata ? payload.showlinedata : ''
                  }],
                  lineStyle: {
                    opacity: payload.showlinedata ? 100 : 0,
                    color: 'red'
                  },
                  label: {
                    show: payload.showlinedata ? true : false
                  }
                }
              };
              tempSeriesRx = {
                name: name + ' ' + "down",
                data: [],
                type: "line",
                nettype: dataSource[key].nettp,
                showSymbol: false,
                smoothMonotone: "x",
                color: color[1],
                smooth: true,
                animation: false,
                markLine: {
                  data: [{
                    name: "Horizontal line with a Y-axis value of bandwidth * 0.9",
                    yAxis: payload && payload.showlinedata ? payload.showlinedata : ''
                  }],
                  lineStyle: {
                    opacity: payload.showlinedata ? 100 : 0,
                    color: 'red'
                  },
                  label: {
                    show: payload.showlinedata ? true : false
                  }
                }
              };
              for (subKey in dataSource[key].bands) {
                timeArr = [];
                if (dataSource[key].bands.length > 3 && dataSource[key].bands[Number(subKey) - 1]) {
                  if (dataSource[key].bands[Number(subKey) - 1].time && dataSource[key].bands[subKey].time - dataSource[key].bands[Number(subKey) - 1].time > timeInterval) {
                    timeArr.push(moment.unix(dataSource[key].bands[Number(subKey) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                    timeArr.push(moment.unix(dataSource[key].bands[Number(subKey)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                  }
                }
                band = dataSource[key].bands[subKey];
                time = moment.unix(band.time).format("YYYY-MM-DD HH:mm:ss");
                if (timeArr.length > 0) {
                  for (i in timeArr) {
                    tempSeriesTx.data.push([timeArr[i], null]);
                    tempSeriesRx.data.push([timeArr[i], null]);
                  }
                }
                tempSeriesTx.data.push([time, band.ratetx]);
                tempSeriesRx.data.push([time, band.raterx]); // tempSeriesTx.data.push([time, (band.ratetx / 1024).toFixed(4)]);
                // tempSeriesRx.data.push([time, (band.raterx / 1024).toFixed(4)]);
              }
              speedSeries.push(tempSeriesTx);
              speedSeries.push(tempSeriesRx);
              _context15.next = 13;
              break;
            case 46:
              tunnelInfoSeries.speed = speedSeries;
              _context15.next = 49;
              return put({
                type: "update",
                payload: {
                  tunnelInfoSeries: tunnelInfoSeries
                }
              });
            case 49:
              //speed series 获取数据构建
              //rttGet series 构建
              rttGetSeries = [];
              rttSeries = {
                name: "TCP latency",
                data: [],
                type: "line",
                yAxisIndex: 0,
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#FF8D23"
                },
                itemStyle: {
                  color: "#FF8D23"
                }
              };
              getSeries = {
                name: "Get",
                data: [],
                type: "line",
                yAxisIndex: 1,
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#059CAD"
                },
                itemStyle: {
                  color: "#059CAD"
                }
              };
              getSeries2 = {
                name: "GET",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#B4CECE"
                },
                itemStyle: {
                  color: "#B4CECE"
                }
              };
              _context15.next = 55;
              return call(_get_tunnel_property, payload);
            case 55:
              alltunnelData = _context15.sent;
              _context15.next = 58;
              return call(_get_internet_property, payload);
            case 58:
              allInternetData = _context15.sent;
              rttData = allInternetData;
              _context15.next = 62;
              return call(get_tunnel_agent, payload);
            case 62:
              rttGetData = _context15.sent;
              realPathData = {};
              if (sessionStorage.getItem("role") === "companystaff" || sessionStorage.getItem("role") === 'company') {
                _context15.next = 68;
                break;
              }
              _context15.next = 67;
              return call(get_real_working_path, payload);
            case 67:
              realPathData = _context15.sent;
            case 68:
              realPathSeries = [];
              realPathSeriesJitter = {
                name: "jitter",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false
              };
              realPathSeriesRtt = {
                name: "rtt",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false
              };
              realPathSeriesMiss = {
                name: "miss",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false
              };
              if (realPathData.retcode === 0) {
                for (_key6 in realPathData.data) {
                  _timeArr = [];
                  if (realPathData.data.length > 3 && realPathData.data[Number(_key6) - 1]) {
                    if (realPathData.data[Number(_key6) - 1].time && realPathData.data[_key6].time - realPathData.data[Number(_key6) - 1].time > timeInterval) {
                      _timeArr.push(moment.unix(realPathData.data[Number(_key6) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                      _timeArr.push(moment.unix(realPathData.data[Number(_key6)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                    }
                  }
                  _time = moment.unix(realPathData.data[_key6].time).format("YYYY-MM-DD HH:mm:ss");
                  tempGet = [_time, realPathData.data[_key6].get];
                  if (_timeArr.length > 0) {
                    for (_i6 in _timeArr) {
                      realPathSeriesJitter.data.push([_timeArr[_i6], null]);
                      realPathSeriesRtt.data.push([_timeArr[_i6], null]);
                      realPathSeriesMiss.data.push([_timeArr[_i6], null]);
                    }
                  }
                  realPathSeriesJitter.data.push([_time, realPathData.data[_key6].jitter]);
                  realPathSeriesRtt.data.push([_time, realPathData.data[_key6].rtt]);
                  realPathSeriesMiss.data.push([_time, realPathData.data[_key6].miss]); // realPathSeries.push({
                  //     name:'jitter',
                  //     data:realPathData.data[key].jitter
                  // });
                }
                realPathSeries.push(realPathSeriesJitter);
                realPathSeries.push(realPathSeriesRtt);
                realPathSeries.push(realPathSeriesMiss);
              }
              tunnelInfoSeries.realPath = realPathSeries;
              _context15.next = 76;
              return put({
                type: "update",
                payload: {
                  tunnelInfoSeries: tunnelInfoSeries
                }
              });
            case 76:
              if (rttGetData.msg === "ok") {
                for (_key8 in rttGetData.data) {
                  _timeArr2 = [];
                  ;
                  if (rttGetData.data.length > 3 && rttGetData.data[Number(_key8) - 1]) {
                    if (rttGetData.data[Number(_key8) - 1].time && rttGetData.data[_key8].time - rttGetData.data[Number(_key8) - 1].time > timeInterval) {
                      _timeArr2.push(moment.unix(rttGetData.data[Number(_key8) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                      _timeArr2.push(moment.unix(rttGetData.data[Number(_key8)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                    }
                  }
                  _time2 = moment.unix(rttGetData.data[_key8].time).format("YYYY-MM-DD HH:mm:ss");
                  _tempGet = [_time2, rttGetData.data[_key8].get];
                  if (_timeArr2.length > 0) {
                    for (_i8 in _timeArr2) {
                      getSeries.data.push([_timeArr2[_i8], null]);
                      getSeries2.data.push([_timeArr2[_i8], null]);
                    }
                  }
                  getSeries.data.push(_tempGet);
                  getSeries2.data.push(_tempGet);
                }
              }
              if (rttData.msg === "ok") {
                for (_key10 in rttData.data) {
                  _timeArr3 = [];
                  ;
                  if (rttData.data.length > 3 && rttData.data[Number(_key10) - 1]) {
                    if (rttData.data[Number(_key10) - 1].time && rttData.data[_key10].time - rttData.data[Number(_key10) - 1].time > timeInterval) {
                      _timeArr3.push(moment.unix(rttData.data[Number(_key10) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                      _timeArr3.push(moment.unix(rttData.data[Number(_key10)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                    }
                  }
                  _time3 = moment.unix(rttData.data[_key10].time).format("YYYY-MM-DD HH:mm:ss");
                  tempRtt = [_time3, rttData.data[_key10].rtt];
                  if (_timeArr3.length > 0) {
                    for (_i10 in _timeArr3) {
                      rttSeries.data.push([_timeArr3[_i10], null]);
                    }
                  }
                  rttSeries.data.push(tempRtt);
                }
              }
              rttGetSeries.push(rttSeries);
              if (sessionStorage.getItem("role") !== "company" && sessionStorage.getItem("role") !== "companystaff") {
                rttGetSeries.push(getSeries);
              }
              tunnelInfoSeries.rttGet = rttGetSeries;
              tunnelInfoSeries.rtt = [rttSeries];
              tunnelInfoSeries.getData = [getSeries2];
              _context15.next = 85;
              return put({
                type: "update",
                payload: {
                  tunnelInfoSeries: tunnelInfoSeries
                }
              });
            case 85:
              _context15.next = 87;
              return call(get_session_ct, payload);
            case 87:
              sessionData = _context15.sent; //session series 构建
              sessionSeries = {
                name: "Number of sessions",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#B4CECE"
                },
                itemStyle: {
                  color: "#B4CECE"
                }
              };
              if (sessionData.msg === "ok") {
                for (_key12 in sessionData.data) {
                  _timeArr4 = [];
                  ;
                  if (sessionData.data.length > 3 && sessionData.data[Number(_key12) - 1]) {
                    if (sessionData.data[Number(_key12) - 1].time && sessionData.data[_key12].time - sessionData.data[Number(_key12) - 1].time > timeInterval) {
                      _timeArr4.push(moment.unix(sessionData.data[Number(_key12) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                      _timeArr4.push(moment.unix(sessionData.data[Number(_key12)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                    }
                  }
                  if (_timeArr4.length > 0) {
                    for (_i12 in _timeArr4) {
                      sessionSeries.data.push([_timeArr4[_i12], null]);
                    }
                  }
                  temp = [moment.unix(sessionData.data[_key12].time).format("YYYY-MM-DD HH:mm:ss"), sessionData.data[_key12].counts];
                  sessionSeries.data.push(temp);
                }
              }
              tunnelInfoSeries.session = [sessionSeries];
              _context15.next = 93;
              return put({
                type: "update",
                payload: {
                  tunnelInfoSeries: tunnelInfoSeries
                }
              });
            case 93:
              //session series 获取数据构建
              jitterData = alltunnelData;
              jitterSeries = {
                name: "shake",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#B4CECE"
                },
                itemStyle: {
                  color: "#B4CECE"
                }
              };
              if (jitterData.msg === "ok") {
                for (_key14 in jitterData.data) {
                  // let timeArr: any[] = [];
                  // if (jitterData.data.length > 3 && jitterData.data[Number(key) - 1]) {
                  //     if (jitterData.data[Number(key) - 1].time && jitterData.data[key].time - jitterData.data[Number(key) - 1].time > timeInterval) {
                  //         timeArr.push(moment.unix(jitterData.data[Number(key) - 1].time + timeInterval-1).format("YYYY-MM-DD HH:mm:ss"));
                  //         timeArr.push(moment.unix(jitterData.data[Number(key)].time - timeInterval+1).format("YYYY-MM-DD HH:mm:ss"));
                  //     }
                  // }
                  // if(timeArr.length>0){
                  //     for(let i in timeArr){
                  //         jitterSeries.data.push([timeArr[i], null]);
                  //     }
                  // }
                  _temp = [moment.unix(jitterData.data[_key14].time).format("YYYY-MM-DD HH:mm:ss"), jitterData.data[_key14].jitter];
                  jitterSeries.data.push(_temp);
                }
              }
              tunnelInfoSeries.jitter = [jitterSeries]; // pingDetectData.data.sort((a,b)=>{
              //     return a.last_report_time - b.last_report_time
              // })
              JitterAndRttSeries = [{
                name: "delay",
                type: 'line',
                data: [],
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false
              }, {
                name: "shake",
                type: 'line',
                data: [],
                // yAxisIndex:1,
                // yAxisIndex:0,
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false
              }];
              pingDetectLossSeries = {
                name: "Packet loss",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#059CAD"
                },
                itemStyle: {
                  color: "#059CAD"
                }
              };
              if (!payload.showChart) {
                _context15.next = 108;
                break;
              }
              _context15.next = 102;
              return call(get_link_ping_detect_detail, payload);
            case 102:
              pingDetectData = _context15.sent;
              timeIntervalForPing = 0;
              if (start_date && end_date && end_date.diff(start_date, "seconds")) {
                if (end_date.diff(start_date, "seconds") <= 86400) {
                  //24小时 60s
                  timeIntervalForPing = 180;
                } else if (end_date.diff(start_date, "seconds") > 86400 && end_date.diff(start_date, "month") <= 1) {
                  //大于24小时，小于1个月 30分钟 1800
                  timeIntervalForPing = 5400;
                } else {
                  //大于一个月 1小时
                  timeIntervalForPing = 10800;
                }
              }
              if (pingDetectData.retcode === 0) {
                for (_key16 in pingDetectData.data) {
                  _timeArr5 = [];
                  jittertemp = [moment.unix(pingDetectData.data[_key16].report_time).format("YYYY-MM-DD HH:mm:ss"), pingDetectData.data[_key16].loss == 100 ? null : pingDetectData.data[_key16].jitter, pingDetectData.data[_key16].address];
                  rtttemp = [moment.unix(pingDetectData.data[_key16].report_time).format("YYYY-MM-DD HH:mm:ss"), pingDetectData.data[_key16].loss == 100 ? null : pingDetectData.data[_key16].rtt, pingDetectData.data[_key16].address];
                  losstemp = [moment.unix(pingDetectData.data[_key16].report_time).format("YYYY-MM-DD HH:mm:ss"), pingDetectData.data[_key16].loss, pingDetectData.data[_key16].address];
                  if (pingDetectData.data.length > 3 && pingDetectData.data[Number(_key16) - 1]) {
                    if (pingDetectData.data[Number(_key16) - 1].report_time && pingDetectData.data[_key16].report_time - pingDetectData.data[Number(_key16) - 1].report_time > timeIntervalForPing) {
                      _timeArr5.push(moment.unix(pingDetectData.data[Number(_key16) - 1].report_time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                      _timeArr5.push(moment.unix(pingDetectData.data[Number(_key16)].report_time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                    }
                  }
                  if (_timeArr5.length > 0) {
                    for (_i14 in _timeArr5) {
                      JitterAndRttSeries[0].data.push([_timeArr5[_i14], null, null]);
                      JitterAndRttSeries[1].data.push(_timeArr5[_i14], null, null);
                      pingDetectLossSeries.data.push(_timeArr5[_i14], null, null);
                    }
                  } // console.log(timeArr,'22222')
                  JitterAndRttSeries[0].data.push(rtttemp);
                  JitterAndRttSeries[1].data.push(jittertemp);
                  pingDetectLossSeries.data.push(losstemp);
                }
              }
              tunnelInfoSeries.pingDetectLoss = pingDetectLossSeries;
              tunnelInfoSeries.JitterAndRtt = JitterAndRttSeries;
            case 108:
              _context15.next = 110;
              return put({
                type: "update",
                payload: {
                  tunnelInfoSeries: tunnelInfoSeries
                }
              });
            case 110:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    get_days4g: function get_days4g(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData, days4gSeries, monthTotal, key, timeArr, timeInterval, time, flow, i;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_get_days4g, payload);
            case 2:
              backData = _context16.sent;
              days4gSeries = [{
                type: "line",
                data: [],
                name: "Daily traffic",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false
              }];
              monthTotal = 0;
              if (backData.msg === "ok" || backData.retcode === 0) {
                for (key in backData.data) {
                  timeArr = [];
                  timeInterval = 259200;
                  if (backData.data.length > 3 && backData.data[Number(key) - 1]) {
                    if (backData.data[Number(key) - 1].time && backData.data[key].time - backData.data[Number(key) - 1].time > timeInterval) {
                      timeArr.push(moment.unix(backData.data[Number(key) - 1].time + timeInterval - 1).format("YYYY-MM-DD"));
                      timeArr.push(moment.unix(backData.data[Number(key)].time - timeInterval + 1).format("YYYY-MM-DD"));
                    }
                  }
                  time = moment.unix(backData.data[key].time).format("YYYY-MM-DD");
                  flow = backData.data[key].flow;
                  monthTotal += flow;
                  flow = (flow / 1024 / 1024).toFixed(2);
                  if (backData.data.length > 0) {
                    if (timeArr.length > 0) {
                      for (i in timeArr) {
                        days4gSeries[0].data.push([timeArr[i], null]);
                      }
                    }
                    days4gSeries[0].data.push([time, flow]);
                  }
                }
              }
              _context16.next = 8;
              return put({
                type: "update",
                payload: {
                  days4gSeries: days4gSeries,
                  monthTotal: (monthTotal / 1024 / 1024).toFixed(2)
                }
              });
            case 8:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    get_wifi_config_file: function get_wifi_config_file(_ref33, _ref34) {
      var payload = _ref33.payload;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return call(_get_wifi_config_file, payload);
            case 2:
              backData = _context17.sent;
              _context17.next = 5;
              return put({
                type: "update",
                payload: {
                  wifiFile: backData.result.replace(/\n/gm, "<br/>").replace(/\t/gm, "&emsp;&emsp;&emsp;&emsp;")
                }
              });
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    get_wifi: function get_wifi(_ref35, _ref36) {
      var payload = _ref35.payload;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return call(_get_wifi, payload);
            case 2:
              backData = _context18.sent;
              _context18.next = 5;
              return put({
                type: "update",
                payload: {
                  wifiInfo: backData.result
                }
              });
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    //网络参数
    get_cpe_template_agency: function get_cpe_template_agency(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_get_cpe_template_agency, payload);
            case 2:
              backData = _context19.sent;
              _context19.next = 5;
              return put({
                type: "update",
                payload: {
                  ctaId: backData.result[0].id
                }
              });
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    },
    get_cpe_template: function get_cpe_template(_ref39, _ref40) {
      var payload = _ref39.payload;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(_get_cpe_template_agency, payload);
            case 2:
              backData = _context20.sent;
              _context20.next = 5;
              return put({
                type: "update",
                payload: {
                  cpeTemplate: backData.result
                }
              });
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      })();
    },
    get_physical_ports_info: function get_physical_ports_info(_ref41, _ref42) {
      var payload = _ref41.payload;
      var call = _ref42.call,
        put = _ref42.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return call(_get_physical_ports_info, payload);
            case 2:
              backData = _context21.sent;
              _context21.next = 5;
              return put({
                type: "update",
                payload: {
                  physical: backData.result
                }
              });
            case 5:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      })();
    },
    //ap设备
    get_ap_wifi: function get_ap_wifi(_ref43, _ref44) {
      var payload = _ref43.payload;
      var call = _ref44.call,
        put = _ref44.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return call(_get_ap_wifi, payload);
            case 2:
              backData = _context22.sent;
              _context22.next = 5;
              return put({
                type: "update",
                payload: {
                  wifiList: backData.result
                }
              });
            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      })();
    },
    get_ap_lan: function get_ap_lan(_ref45, _ref46) {
      var payload = _ref45.payload;
      var call = _ref46.call,
        put = _ref46.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return call(_get_ap_lan, payload);
            case 2:
              backData = _context23.sent;
              _context23.next = 5;
              return put({
                type: "update",
                payload: {
                  dataLan: backData.result
                }
              });
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      })();
    },
    get_ap_static_ip: function get_ap_static_ip(_ref47, _ref48) {
      var payload = _ref47.payload;
      var call = _ref48.call,
        put = _ref48.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return call(_get_ap_static_ip, payload);
            case 2:
              backData = _context24.sent;
              _context24.next = 5;
              return put({
                type: "update",
                payload: {
                  apStatic: backData.result
                }
              });
            case 5:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      })();
    },
    create_ap_static_ip: function create_ap_static_ip(_ref49, _ref50) {
      var payload = _ref49.payload;
      var call = _ref50.call,
        put = _ref50.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return call(_create_ap_static_ip, payload.update);
            case 2:
              backData = _context25.sent;
              if (backData.success) {
                BossMessage(true, "Successfully added");
              } else {
                BossMessage(false, "Add failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      })();
    },
    update_ap_static_ip: function update_ap_static_ip(_ref51, _ref52) {
      var payload = _ref51.payload;
      var call = _ref52.call,
        put = _ref52.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return call(_update_ap_static_ip, payload.update);
            case 2:
              backData = _context26.sent;
              if (backData.success) {
                BossMessage(true, "Successfully modified");
              } else {
                BossMessage(false, "Modification failed" + backData.result);
              }
            case 4:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      })();
    },
    delete_ap_static_ip: function delete_ap_static_ip(_ref53, _ref54) {
      var payload = _ref53.payload;
      var call = _ref54.call,
        put = _ref54.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return call(_delete_ap_static_ip, payload.data);
            case 2:
              backData = _context27.sent;
              if (!backData.success) {
                _context27.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context27.next = 7;
              return put({
                type: "get_ap_static_ip",
                payload: {
                  net_id: payload.init.net_id,
                  ap_lan_id: payload.init.cta_lan_id
                }
              });
            case 7:
              _context27.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      })();
    },
    get_ap_template_agency: function get_ap_template_agency(_ref55, _ref56) {
      var payload = _ref55.payload;
      var call = _ref56.call,
        put = _ref56.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return call(get_latest_lan_name, payload);
            case 2:
              backData = _context28.sent;
              _context28.next = 5;
              return put({
                type: "update",
                payload: {
                  apTemplate: backData.result
                }
              });
            case 5:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      })();
    },
    delete_ap_lan: function delete_ap_lan(_ref57, _ref58) {
      var payload = _ref57.payload;
      var call = _ref58.call,
        put = _ref58.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return call(_delete_ap_lan, payload);
            case 2:
              backData = _context29.sent;
              if (!backData.success) {
                _context29.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context29.next = 7;
              return put({
                type: "get_ap_lan",
                payload: {
                  device_id: payload.cta_id
                }
              });
            case 7:
              _context29.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      })();
    },
    create_ap_lan: function create_ap_lan(_ref59, _ref60) {
      var payload = _ref59.payload;
      var call = _ref60.call,
        put = _ref60.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return call(_create_ap_lan, payload.update);
            case 2:
              backData = _context30.sent;
              if (backData.success) {
                BossMessage(true, "Successfully added");
              } else {
                BossMessage(false, "Add failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      })();
    },
    update_ap_lan: function update_ap_lan(_ref61, _ref62) {
      var payload = _ref61.payload;
      var call = _ref62.call,
        put = _ref62.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return call(_update_ap_lan, payload.update);
            case 2:
              backData = _context31.sent;
              if (backData.success) {
                BossMessage(true, "Update successful");
              } else {
                BossMessage(false, "Update failed" + backData.result);
              }
            case 4:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      })();
    },
    delete_ap_wifi: function delete_ap_wifi(_ref63, _ref64) {
      var payload = _ref63.payload;
      var call = _ref64.call,
        put = _ref64.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return call(_delete_ap_wifi, payload);
            case 2:
              backData = _context32.sent;
              if (!backData.success) {
                _context32.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context32.next = 7;
              return put({
                type: "get_ap_wifi",
                payload: {
                  device_id: payload.device_id
                }
              });
            case 7:
              _context32.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      })();
    },
    create_ap_wifi: function create_ap_wifi(_ref65, _ref66) {
      var payload = _ref65.payload;
      var call = _ref66.call,
        put = _ref66.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return call(_create_ap_wifi, payload.update);
            case 2:
              backData = _context33.sent;
              if (backData.success) {
                BossMessage(true, "Successfully added");
              } else {
                BossMessage(false, "Add failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      })();
    },
    update_ap_wifi: function update_ap_wifi(_ref67, _ref68) {
      var payload = _ref67.payload;
      var call = _ref68.call,
        put = _ref68.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return call(_update_ap_wifi, payload.update);
            case 2:
              backData = _context34.sent;
              if (backData.success) {
                BossMessage(true, "Update successful");
              } else {
                BossMessage(false, "Update failed" + backData.result);
              }
            case 4:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      })();
    },
    get_path_seg: function get_path_seg(_ref69, _ref70) {
      var payload = _ref69.payload;
      var call = _ref70.call,
        put = _ref70.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return call(_get_path_seg, payload);
            case 2:
              backData = _context35.sent;
              if (!(backData.message === 'success')) {
                _context35.next = 8;
                break;
              }
              _context35.next = 6;
              return put({
                type: "update",
                payload: {
                  pathInfo: backData.path,
                  pathSeg: backData.result || []
                }
              });
            case 6:
              _context35.next = 11;
              break;
            case 8:
              BossMessage(false, "Query failed");
              _context35.next = 11;
              return put({
                type: "update",
                payload: {
                  pathInfo: {
                    dst_info: {},
                    src_info: {
                      ip_table_list: []
                    },
                    path_info: []
                  },
                  pathSeg: []
                }
              });
            case 11:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      })();
    },
    get_start_end_ip: function get_start_end_ip(_ref71, _ref72) {
      var payload = _ref71.payload;
      var call = _ref72.call,
        put = _ref72.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return call(_get_start_end_ip, payload);
            case 2:
              backData = _context36.sent;
              _context36.next = 5;
              return put({
                type: "update",
                payload: {
                  ipPool: backData.result
                }
              });
            case 5:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      })();
    },
    get_bgp: function get_bgp(_ref73, _ref74) {
      var payload = _ref73.payload;
      var call = _ref74.call,
        put = _ref74.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return call(_get_bgp, payload);
            case 2:
              backData = _context37.sent;
              _context37.next = 5;
              return put({
                type: "update",
                payload: {
                  bgpList: backData.result
                }
              });
            case 5:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      })();
    },
    get_bgp_his: function get_bgp_his(_ref75, _ref76) {
      var payload = _ref75.payload;
      var call = _ref76.call,
        put = _ref76.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              _context38.next = 2;
              return call(_get_bgp_his, payload);
            case 2:
              backData = _context38.sent;
              _context38.next = 5;
              return put({
                type: "update",
                payload: {
                  bgphisList: backData.data
                }
              });
            case 5:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      })();
    },
    get_bgp_ip: function get_bgp_ip(_ref77, _ref78) {
      var payload = _ref77.payload;
      var call = _ref78.call,
        put = _ref78.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return call(_get_bgp_ip, payload);
            case 2:
              backData = _context39.sent;
              _context39.next = 5;
              return put({
                type: "update",
                payload: {
                  bgpipList: {
                    recv: backData.result.recv,
                    send: backData.result.send
                  }
                }
              });
            case 5:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      })();
    },
    get_4g_strength_latest: function get_4g_strength_latest(_ref79, _ref80) {
      var payload = _ref79.payload;
      var call = _ref80.call,
        put = _ref80.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return call(_get_4g_strength_latest, payload);
            case 2:
              backData = _context40.sent;
              _context40.next = 5;
              return put({
                type: "update",
                payload: {
                  g4_strength_latest: backData.data
                }
              });
            case 5:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      })();
    },
    get_4g_strength_line: function get_4g_strength_line(_ref81, _ref82) {
      var payload = _ref81.payload;
      var call = _ref82.call,
        put = _ref82.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var backData, series_4g_strength_line, start_date, end_date, timeInterval, i, timeArr, time, _i16;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return call(_get_4g_strength_line, payload);
            case 2:
              backData = _context41.sent;
              series_4g_strength_line = {
                name: "signal intensity ",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#B4CECE"
                },
                itemStyle: {
                  color: "#B4CECE"
                }
              };
              start_date = moment(payload.start_tm, "YYYY-MM-DD HH:mm:ss");
              end_date = moment(payload.end_tm, "YYYY-MM-DD HH:mm:ss");
              timeInterval = 0;
              if (start_date && end_date && end_date.diff(start_date, "seconds")) {
                if (end_date.diff(start_date, "seconds") <= 86400) {
                  //24小时
                  timeInterval = 90;
                } else if (end_date.diff(start_date, "seconds") > 86400 && end_date.diff(start_date, "month") <= 1) {
                  //大于24小时，小于1个月
                  timeInterval = 3600;
                } else {
                  //大于一个月
                  timeInterval = 43200;
                }
              }
              if (backData.data.length > 0) {
                for (i = 0; i < backData.data.length; i++) {
                  timeArr = [];
                  if (backData.data.length > 3 && backData.data[Number(i) - 1]) {
                    if (backData.data[Number(i) - 1].time && backData.data[i].time - backData.data[Number(i) - 1].time > timeInterval) {
                      timeArr.push(moment.unix(backData.data[Number(i) - 1].time + timeInterval - 1).format("YYYY-MM-DD HH:mm:ss"));
                      timeArr.push(moment.unix(backData.data[Number(i)].time - timeInterval + 1).format("YYYY-MM-DD HH:mm:ss"));
                    }
                  }
                  time = moment.unix(backData.data[i].time).format("YYYY-MM-DD HH:mm:ss");
                  if (backData.data.length > 0) {
                    if (timeArr.length > 0) {
                      for (_i16 in timeArr) {
                        series_4g_strength_line.data.push([timeArr[_i16], null]);
                      }
                    }
                    series_4g_strength_line.data.push([time, backData.data[i].strength]);
                  }
                }
              }
              _context41.next = 11;
              return put({
                type: "update",
                payload: {
                  series_4g_strength_line: [series_4g_strength_line]
                }
              });
            case 11:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      })();
    },
    get_tunnel_property: function get_tunnel_property(_ref83, _ref84) {
      var payload = _ref83.payload;
      var call = _ref84.call,
        put = _ref84.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var backData, tunnel_property_data, i, data, time;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return call(_get_tunnel_property, payload);
            case 2:
              backData = _context42.sent;
              tunnel_property_data = {
                rtt: [],
                jitter: [],
                miss: []
              };
              if (backData.data.length > 0) {
                for (i = 0; i < backData.data.length; i++) {
                  data = backData.data[i];
                  time = moment.unix(data.time).format("YYYY-MM-DD HH:mm:ss");
                  tunnel_property_data.rtt.push([time, data.rtt]);
                  tunnel_property_data.jitter.push([time, data.jitter]);
                  tunnel_property_data.miss.push([time, data.miss]);
                }
              }
              _context42.next = 7;
              return put({
                type: "update",
                payload: {
                  tunnel_property_data: tunnel_property_data
                }
              });
            case 7:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      })();
    },
    get_internet_property: function get_internet_property(_ref85, _ref86) {
      var payload = _ref85.payload;
      var call = _ref86.call,
        put = _ref86.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var backData, internet_property_data, i, data, time;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return call(_get_internet_property, payload);
            case 2:
              backData = _context43.sent;
              internet_property_data = {
                rtt: [],
                jitter: [],
                miss: []
              };
              if (backData.data.length > 0) {
                for (i = 0; i < backData.data.length; i++) {
                  data = backData.data[i];
                  time = moment.unix(data.time).format("YYYY-MM-DD HH:mm:ss");
                  internet_property_data.rtt.push([time, data.rtt]);
                  internet_property_data.jitter.push([time, data.jitter]);
                  internet_property_data.miss.push([time, data.miss]);
                }
              }
              _context43.next = 7;
              return put({
                type: "update",
                payload: {
                  internet_property_data: internet_property_data
                }
              });
            case 7:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      })();
    },
    get_speedSeries_Data: function get_speedSeries_Data(_ref87, _ref88) {
      var payload = _ref87.payload;
      var call = _ref88.call,
        put = _ref88.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        var speedSeries, speedData, multibandData, dataSource, name, key, tempSeriesTx, tempSeriesRx, subKey, band, time;
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              speedSeries = [];
              _context44.next = 3;
              return call(get_multi_band, payload);
            case 3:
              multibandData = _context44.sent;
              dataSource = multibandData.data;
              name = "";
              _context44.t0 = _regeneratorRuntime().keys(dataSource);
            case 7:
              if ((_context44.t1 = _context44.t0()).done) {
                _context44.next = 33;
                break;
              }
              key = _context44.t1.value;
              _context44.t2 = dataSource[key].nettp;
              _context44.next = _context44.t2 === 1000 ? 12 : _context44.t2 === 0 ? 14 : _context44.t2 === 1 ? 16 : _context44.t2 === 2 ? 18 : _context44.t2 === 3 ? 20 : _context44.t2 === 4 ? 22 : 24;
              break;
            case 12:
              name = "Total rate";
              return _context44.abrupt("break", 26);
            case 14:
              name = "MPLS";
              return _context44.abrupt("break", 26);
            case 16:
              name = "INTERNET";
              return _context44.abrupt("break", 26);
            case 18:
              name = "4G";
              return _context44.abrupt("break", 26);
            case 20:
              name = "INTERNET_PRIVIATE";
              return _context44.abrupt("break", 26);
            case 22:
              name = "4G_PRIVIATE";
              return _context44.abrupt("break", 26);
            case 24:
              name = "";
              return _context44.abrupt("break", 26);
            case 26:
              tempSeriesTx = {
                name: name + ' ' + "upstream",
                data: [],
                type: "line",
                nettype: dataSource[key].nettp,
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false
              };
              tempSeriesRx = {
                name: name + ' ' + "down",
                data: [],
                type: "line",
                nettype: dataSource[key].nettp,
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false
              };
              for (subKey in dataSource[key].bands) {
                band = dataSource[key].bands[subKey];
                time = moment.unix(band.time).format("YYYY-MM-DD HH:mm:ss");
                tempSeriesTx.data.push([time, band.ratetx]);
                tempSeriesRx.data.push([time, band.raterx]); // tempSeriesTx.data.push([time, (band.ratetx / 1024).toFixed(4)]);
                // tempSeriesRx.data.push([time, (band.raterx / 1024).toFixed(4)]);
              }
              speedSeries.push(tempSeriesTx);
              speedSeries.push(tempSeriesRx);
              _context44.next = 7;
              break;
            case 33:
              _context44.next = 35;
              return put({
                type: "update",
                payload: {
                  multiBandSeries: speedSeries
                }
              });
            case 35:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      })();
    },
    get_line_config: function get_line_config(_ref89, _ref90) {
      var payload = _ref89.payload;
      var call = _ref90.call,
        put = _ref90.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        var backData, ispData;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return call(_get_line_config, payload);
            case 2:
              backData = _context45.sent;
              ispData = [];
              if (backData.data && backData.data.list && backData.data.list.length > 0) {
                ispData = backData.data.list.map(function (item) {
                  return ipTypeMap(item.ip_type) + ' ' + item.isp + ' ' + item.wan_name + ' ' + item.ip + ' ' + item.port;
                });
              }
              _context45.next = 7;
              return put({
                type: "update",
                payload: {
                  ispData: ispData.join(',')
                }
              });
            case 7:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      })();
    },
    get_link_ping_detect: function get_link_ping_detect(_ref91, _ref92) {
      var payload = _ref91.payload,
        callback = _ref91.callback;
      var call = _ref92.call,
        put = _ref92.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return call(_get_link_ping_detect, payload);
            case 2:
              backData = _context46.sent;
              if (callback && typeof callback === 'function') {
                callback(backData.data);
              }
            case 4:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};